import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "40",
  viewBox: "0 0 56 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "56",
      height: "40",
      rx: "8",
      fill: "#DAF6FF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.792 19.552C8.792 14.512 12.296 10.96 17.264 10.96C21.272 10.96 24.296 13.216 25.256 16.864H20.744C20.048 15.424 18.776 14.704 17.216 14.704C14.696 14.704 12.968 16.576 12.968 19.552C12.968 22.528 14.696 24.4 17.216 24.4C18.776 24.4 20.048 23.68 20.744 22.24H25.256C24.296 25.888 21.272 28.12 17.264 28.12C12.296 28.12 8.792 24.592 8.792 19.552Z",
      fill: "#2B1072"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "12",
      r: "6",
      fill: "#2B1072"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "28",
      r: "6",
      fill: "#446CFC"
    }, null, -1)
  ])))
}
export default { render: render }